import React, { useEffect, useState } from "react"
import agreementSignIcon from "../../assets/images/agreement-sign.png"
import { useLazyGetDocSigningLinkQuery } from "store/api/investors/reports.api"
import Spinners from "components/Common/Spinner"
import { Col, Modal, ModalBody, Row } from "reactstrap"
import { useSelector } from "react-redux"

const ICDAgreementBox = ({ open, setOpen, template_type, icd_id }) => {
  const { userType } = useSelector((state) => state.user)
  const [trigger, { isFetching }] = useLazyGetDocSigningLinkQuery()
  const [link, setLink] = useState("")
  const [linkOpen, setLinkOpen] = useState(false)

  const getLink = async () => {
    try {
      const { data } = await trigger({
        template_type,
        icd_id,
        redirection_url: window.location.href,
      }).unwrap()
      setLink(data.url)
      if (data.showModal) {
        setLinkOpen(true)
      }
    } catch (error) { }
  }

  useEffect(() => {
    if (open) getLink()
  }, [open])

  return (
    <React.Fragment>
      <Modal
        isOpen={linkOpen}
        toggle={() => {
          setOpen(!open)
          setLinkOpen(!linkOpen)
        }}
        size="sm"
        centered
        style={{
          border: 0,
          minWidth: "350px",
        }}
      >
        <ModalBody
          style={{
            padding: 0,
          }}
        >
          <Row>
            <Col
              xl={12}
              className="investor-dashboard-wrapper"
              style={{
                display: "block",
                padding: 0,
              }}
            >
              <div
                className="investor-card-wrapper"
                style={{
                  display: "block",
                  padding: 0,
                }}
              >
                <div
                  className="verified-investing-section"
                  style={{
                    position: "relative",
                    zIndex: 5,
                  }}
                >
                  <div
                    className="verified-investing-inner-box"
                    style={{
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      <h4>
                        {link
                          ? userType == "WEALTH_PARTNER"
                            ? "Wealth Partner Agreement Shared!"
                            : "ICD Agreement Shared!"
                          : userType === "WEALTH_PARTNER"
                            ? "Wealth Partner Agreement Update!" : "ICD Master Agreement Update!"}
                      </h4>
                      <p>
                        {link
                          ? `
              We have shared an agreement on your registered Phone No.
              Please review and complete the signing process to get verified or you can choose to click on below button to complete.
              `
                          : `You've successfully signed the agreement. We're now waiting for the other
              party to complete their signing process to finalize verification.`}
                      </p>
                    </div>
                    <img height={"100px"} src={agreementSignIcon} alt="" />
                  </div>
                  {link && (
                    <>
                      <a href={link}>
                        <div className="mt-5">
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                          >
                            {isFetching ? <Spinners /> : "Sign Now"}
                          </button>
                        </div>
                      </a>

                      <p className="text-primary text-center mt-1">
                        Note: Please ignore if already signed.
                      </p>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default ICDAgreementBox
